// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { Action, Activity, Issue, IssueKind, ProjectSnapshot, Remediation, Scope, Severity, SharedTableState, SourceSnapshot, State, Status, Summary, TableLayer, TableState, TableStatus } from "../sourceState/sourcestate.generated";
export const addTagTypes = ["source-states"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiProjectsByProjectIdSourceStates: build.query<
        GetApiProjectsByProjectIdSourceStatesApiResponse,
        GetApiProjectsByProjectIdSourceStatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/source-states`,
        }),
        providesTags: ["source-states"],
      }),
      getApiProjectsByProjectIdSourceStatesAndSourceId: build.query<
        GetApiProjectsByProjectIdSourceStatesAndSourceIdApiResponse,
        GetApiProjectsByProjectIdSourceStatesAndSourceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/source-states/${encodeURIComponent(String(queryArg.sourceId))}`,
        }),
        providesTags: ["source-states"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as sourceStateApi };
export type GetApiProjectsByProjectIdSourceStatesApiResponse =
  /** status 200 OK */ { data: SourcestateProjectSnapshot };
export type GetApiProjectsByProjectIdSourceStatesApiArg = {
  /** Project ID */
  projectId: string;
};
export type GetApiProjectsByProjectIdSourceStatesAndSourceIdApiResponse =
  /** status 200 OK */ { data: SourcestateSourceSnapshot };
export type GetApiProjectsByProjectIdSourceStatesAndSourceIdApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type SourcestateAction = Action;
export type SourcestateIssueKind = IssueKind;
export type SourcestateRemediation = Remediation;
export type SourcestateScope = Scope;
export type SourcestateSeverity = Severity;
export type SourcestateIssue = Issue;
export type SourcestateTableLayer = TableLayer;
export type SourcestateStatus = Status;
export type SourcestateSharedTableState = SharedTableState;
export type SourcestateActivity = Activity;
export type SourcestateTableStatus = TableStatus;
export type SourcestateTableState = TableState;
export type SourcestateSummary = Summary;
export type SourcestateState = State;
export type SourcestateSourceSnapshot = SourceSnapshot;
export type SourcestateProjectSnapshot = ProjectSnapshot;
export const {
  useGetApiProjectsByProjectIdSourceStatesQuery,
  useLazyGetApiProjectsByProjectIdSourceStatesQuery,
  useGetApiProjectsByProjectIdSourceStatesAndSourceIdQuery,
  useLazyGetApiProjectsByProjectIdSourceStatesAndSourceIdQuery,
} = injectedRtkApi;
